import { EMPTY_OBJECT } from '../../../../../constants/common'
import { getItemsIds } from '../../../../../utils/common'
import { RATING_TYPE_LIST } from '../../RatingEditModal.constants'

// Permissions apply only when editing an existing feedback:
//   can_edit_rating → the rating stars (absent ⇒ treated as false)
//   can_edit        → the description (text + files)

export function getRatingEditPermissions(ratingData) {
  const hasFeedback = Boolean(ratingData?.feedback?.uuid)
  const permissions = ratingData?.feedback?.permissions

  return {
    isDescriptionEditingDisabled:
      hasFeedback && permissions?.can_edit === false,
    isRatingEditingDisabled:
      hasFeedback && permissions?.can_edit_rating !== true,
  }
}

export function getFeedbackPayload({
  feedbackText,
  files,
  isFilesChanged,
  isTextChanged,
}) {
  return {
    ...(isTextChanged ? { text: feedbackText } : EMPTY_OBJECT),
    ...(isFilesChanged ? { files: getItemsIds(files) } : EMPTY_OBJECT),
  }
}

export function parseRatingData({ data }) {
  return data.results.objects.reduce((result, item) => {
    result[item.rating_type] = {
      id: item.id,
      value: item.value,
    }

    return result
  }, {})
}

export function getIsRatingChanged(rating, initialRating) {
  return RATING_TYPE_LIST.some(
    type =>
      (rating[type]?.value ?? null) !== (initialRating[type]?.value ?? null)
  )
}

export function getFeedbackRatingRequests({
  createRating,
  feedbackUuid,
  rating,
  updateRating,
}) {
  return RATING_TYPE_LIST.reduce((result, type) => {
    if (!rating[type]) {
      return result
    }

    const { id, value } = rating[type]

    if (id) {
      result.push(
        updateRating(id, {
          value,
        })
      )

      return result
    }

    result.push(
      createRating({
        feedback_ratings: [feedbackUuid],
        rating_type: type,
        value,
      })
    )

    return result
  }, [])
}
